/*
* Copyright (c) 2023 Eugenio Espinoza
*/

import React, { useState } from 'react';
import './Newsletter.css';

function Newsletter() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);

  const submit = (e) => {
    e.preventDefault();
    if (!email || !/.+@.+\..+/.test(email)) return;
    setSent(true);
    setEmail('');
  };

  return (
    <section className="mt-news">
      <div className="mt-container mt-news__inner">
        <div className="mt-news__left">
          <span className="mt-eyebrow">The Dispatch · Monthly</span>
          <h2 className="mt-news__title">
            Estrenos, objetos, <em>sesiones privadas.</em>
          </h2>
          <p>
            Una sola carta al mes. Avisos de lanzamientos, ediciones limitadas
            de la tienda y sesiones íntimas antes de que lleguen al público.
          </p>
        </div>

        <form className="mt-news__form" onSubmit={submit}>
          {sent ? (
            <div className="mt-news__sent">
              <span className="mt-kicker">Gracias.</span>
              <p>Te escribimos pronto.</p>
            </div>
          ) : (
            <>
              <label className="mt-news__label" htmlFor="mt-news-email">Tu correo</label>
              <div className="mt-news__row">
                <input
                  id="mt-news-email"
                  type="email"
                  placeholder="name@domain.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
                <button type="submit" aria-label="Subscribe">
                  <span>Subscribe</span>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                    <path d="M5 12h14M13 6l6 6-6 6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </button>
              </div>
              <p className="mt-news__fine">By subscribing you agree to receive occasional emails from Mastered Trax.</p>
            </>
          )}
        </form>
      </div>
    </section>
  );
}

export default Newsletter;
